const AsteriskRequired = () => {
    return <span className="required">*</span>;
}

export default AsteriskRequired;